import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const GoCrmForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
	} = form;

	return (
		<>
			<FormInput label={t("lib:common.word.name")} register={register} name="name" errors={errors} />
			<FormCheck
				type={"switch"}
				errors={errors}
				name="settings.import_contact_groups"
				label={t("modules.app.action.import_contact_groups.title")}
				register={register}
			/>
			<FormCheck
				type={"switch"}
				errors={errors}
				name="settings.import_products"
				label={t("modules.app.action.import_products.title")}
				register={register}
			/>
			<FormCheck
				type={"switch"}
				errors={errors}
				name="settings.auto_link_by_name"
				label={t("modules.app.action.link_by_name.title")}
				register={register}
			/>
			<FormCheck
				type={"switch"}
				errors={errors}
				name="settings.export_all_contacts"
				label={t("modules.app.action.export_all_contacts.title")}
				register={register}
			/>
		</>
	);
};

export default GoCrmForm;
